module.exports = __webpack_public_path__ + "static/media/login-oauth-error-oh-no.09937c05.png";